export interface SeasonBonus {
  /** Completed challenges of the season that pay the bonus. */
  countCompleted: number
  /** Points of the bonus. */
  points: number
}

/**
 * Bonus points for completed challenges of the season, in order: 500 points
 * at 2, 4 and 6 completed challenges (of 7 in the Predicta Season).
 *
 * NOTE: the API does not return these milestones; this mirrors the backend
 * constant `bonusesByCountCompletedChallenges` in micro-back-web3-solana
 * `apps/rewards/src/modules/challenges/background-jobs/constants.ts`.
 * Change both together.
 */
export const SEASON_BONUSES: readonly SeasonBonus[] = [
  { countCompleted: 2, points: 500 },
  { countCompleted: 4, points: 500 },
  { countCompleted: 6, points: 500 }
]
